import {
  TextField as TextFieldCore,
  Button as ButtonComponent,
} from '@material-ui/core';

import * as lib from '~/dependencies';

export const TextField = lib.styled(TextFieldCore)`
    .MuiInputBase-input {
        font-size: 11px !important;
    }
`;

export const DatePickerCustomHeader = lib.styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
    color: #6a6a6a;

    .start-end-labels {
        flex: 1;
        color: #989898;
        font-size: 12px;
        text-align: center;
        padding-left: 12px;
        font-weight: bolder;
        color: #6a6a6a;
    }

    .MuiFormControl-root {
        flex: 1;

        &:last-child {
            margin-left: 5px;
        }
    }

    .MuiNativeSelect-select.MuiNativeSelect-select {
        font-size: 12px;
        text-align: center;
        color: #6a6a6a;
    }

    &:last-child {
        margin-left: 5px;
    }

    .calendar-container {
        padding: 0px;
        color: #fff;

    }
`;

export const CalendarFooterContainer = lib.styled.div`
    padding: 0px;
    color: #fff;

    .calendar-buttons {
        margin-top: 295px;
        padding: 10px;
        border-top: 2px solid #dbdbdb;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
    }

    ..MuiButton-root {
        text-transform: none
    }

    .MuiButton-containedPrimary {
        background-color: #00aeef;

        &:hover {
            background-color: #00aeef;
        }
    }
`;

export const Button = lib.styled(ButtonComponent)`
    & .MuiButton-containedPrimary {
        &:hover: {
            background-color: #00aeef!important;
        }
    }
`;
